import React from 'react';

export default function CkbLogo({
  size = 32,
  className = '',
  showText = false,
  textClassName = 'font-bold tracking-wide',
}) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="CKB"
        width={size}
        height={size}
        className="rounded-full object-cover shrink-0"
        style={{ width: size, height: size }}
      />
      {showText && <span className={textClassName}>CKB</span>}
    </div>
  );
}
